export default __webpack_public_path__ + "8a810c824ffc3dcabf47b8d054e8f0ea.gif";